module.exports = __webpack_public_path__ + "img/qrcode.496bbca3.png";